import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { UserApiService } from '../../shared/services/api/user-api.service';

/**
 * Route guard for the CSM within-tenant data-scope admin surface
 * (`/admin/data-scopes`), GF-4472 Story F.
 *
 * Reads the caller's DB-granted permissions from `GET /user/auth/me` and
 * activates the route only if `data_scope.manage` is present. Tenant users and
 * super_users without the grant are bounced to `/home`.
 *
 * Mirrors `tenantMembershipsAdminGuard` — same surface, different permission
 * key.
 */
export const dataScopeAdminGuard: CanActivateFn = async () => {
  const userApi = inject(UserApiService);
  const router = inject(Router);
  try {
    const me = await firstValueFrom(userApi.getUserData());
    if (me.permissions?.includes('data_scope.manage')) {
      return true;
    }
  } catch {
    // Network / auth issues fall through to redirect — the authTokenInterceptor
    // already handles the 401/403 cases at the HTTP layer.
  }
  return router.createUrlTree(['/home']);
};
